/**
 * AWS Amplify configuration for Cognito authentication
 */
export const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_COGNITO_DOMAIN,
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [window.location.origin],
          redirectSignOut: [window.location.origin],
          responseType: 'code'
        }
      }
    }
  }
};

export const apiConfig = {
  baseURL: import.meta.env.VITE_API_BASE_URL,
  adminGroup: import.meta.env.VITE_ADMIN_GROUP || 'admin'
};
